// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const squawkabilly_blue_plumage: PokeData = {
  "id": 10260,
  "name": "squawkabilly-blue-plumage",
  "height": 6,
  "weight": 24,
  "base_experience": 146,
  "types": [
    PokeType.NORMAL,
    PokeType.FLYING
  ],
  "api_moves": [
    "fly",
    "fury-attack",
    "growl",
    "peck",
    "quick-attack",
    "mimic",
    "reversal",
    "swagger",
    "uproar",
    "torment",
    "facade",
    "taunt",
    "aerial-ace",
    "roost",
    "copycat",
    "brave-bird"
  ],
  "moves": [
    "growl",
    "peck",
    "quick-attack",
    "aerial-ace",
    "roost",
    "brave-bird",
    "headbutt",
    "splash",
    "air-slash",
    "scary-face",
    "gust",
    "scratch",
    "supersonic"
  ],
  "evolution_chain": {
    "id": 488,
    "item": null,
    "species": [
      {
        "name": "squawkabilly",
        "order": 960,
        "types": [
          PokeType.NORMAL,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 105,
    "speed": 145,
    "ability_power": 151
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
